import { useNavigate } from "react-router-dom";

import { Deal } from "@Types/deal";
import useGetDeals from "@Hooks/useDeals";

import styles from "./LatestLoans.module.scss";
import ApplicationPreview from "../Application/ApplicationPreview";

export default function LatestLoans() {
  const navigate = useNavigate();
  const { data, isFetching } = useGetDeals({
    options: {
      limit: 3,
      sort: { createdAt: "desc" },
      page: 1,
    },
  });

  const handleClickShowMore = () => navigate("/loans");
  const handleClickDeal = (loan: Deal) => navigate(`/loans/${loan._id}`);

  return (
    <div className={styles.root}>
      <div className={styles.header}>Latest loans</div>
      <div className={styles.dealContainer}>
        {data && data.length > 0 ? (
          <div>
            {data.map((deal) => (
              <ApplicationPreview
                selectType="icon"
                key={deal._id}
                deal={deal}
                handleClick={handleClickDeal}
              />
            ))}
            <div
              onClick={handleClickShowMore}
              className={styles.showMoreButton}
            >
              Show more
            </div>
          </div>
        ) : isFetching ? (
          <div>Loading...</div>
        ) : (
          <div>No recents loans</div>
        )}
      </div>
    </div>
  );
}
